import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SettingsEthernetIcon(props: IconProps) {
    return <Icon {...props} iconKey={"settings_ethernet"}/>
}
